import { Breakdown } from '@shared/types';
import { FunctionComponent } from 'react';
import Metric from './Metric';
import styles from './styles.module.scss';

const ReviewBreakdown: FunctionComponent<{ breakdown: Breakdown }> = ({ breakdown }) => {
    const metrics = [
        {
            label: 'Material Covered',
            rating: breakdown.material,
        },
        {
            label: 'Facilitator',
            rating: breakdown.facilitator,
        },
        {
            label: 'Organiser',
            rating: breakdown.organiser,
        },
        {
            label: 'Resources Provided',
            rating: breakdown.resources,
        },
        {
            label: 'Location/Delivery',
            rating: breakdown.delivery,
        },
        {
            label: 'Communication',
            rating: breakdown.communication,
        },
    ].map((metric, index) => {
        return <Metric key={index} label={metric.label} rating={metric.rating} />;
    });

    return <div className={styles.reviewsBreakdown}>{metrics}</div>;
};

export default ReviewBreakdown;
